const TestimonialsCarouselData1 = [
    {
        firstname: "Alexander",
        lastname: "harvard",
        designation: "Creative director",
        content: "This theme has a wide variety of options and a really good customer support. Some of the customizations are unlimited but even so the theme still gives a lot of features while prioritizing web speed.",
        img: "https://via.placeholder.com/131x131"
    },
    {
        firstname: "Jeremy",
        lastname: "dupont",
        designation: "Creative director",
        content: "Absolutely amazing theme, flexible and awesome design with possibilities. It's so very easy to use and to customize. Simply the great designs and best theme for WooCommerce, loading fast, customisable.",
        img: "https://via.placeholder.com/131x131"
    },
    {
        firstname: "Lindsay",
        lastname: "swanson",
        designation: "Creative director",
        content: "There are design companies and then there are user experience, design, consulting, interface design. Simply the great designs and best theme for WooCommerce, loading fast, customisable and easy to use.",
        img: "https://via.placeholder.com/131x131"
    }
]

const TestimonialsCarouselData2 = [
    {
        firstname: "Alexander",
        lastname: "harvard",
        designation: "Creative director",
        content: "This theme has a wide variety of options and a really good customer support. Some of the customizations are limited but even so the theme still gives a lot of features while prioritizing web speed.",
        img: 'https://via.placeholder.com/125x125'
    },
    {
        firstname: " Lindsay",
        lastname: "swanson",
        designation: "Creative director",
        content: "I wanted to hire the best and after looking at several other companies, I knew Jacob was the perfect guy. I wanted to hire the best and after looking at several other companies.",
        img: "https://via.placeholder.com/125x125"
    },
    {
        firstname: " Jeremy",
        lastname: "dupont",
        designation: "Creative director",
        content: "Absolutely amazing theme, flexible and awesome design with possibilities. It's so easy to use and to customize. Simply the great designs and best theme for WooCommerce.",
        img: "https://via.placeholder.com/125x125"
    },
]

const TestimonialsCarouselData3 = [
    {
        firstname: "Alexander ",
        lastname: "harvard",
        designation: "Creative director",
        content: "This theme has a wide variety of options and a really good customer support. Some of the customizations are limited but even so the theme still gives a lot of features."
    },
    {
        firstname: "Herman",
        lastname: "miller",
        designation: "Creative director",
        content: "There are design companies and then there are user experience, design, consulting, interface design. I wanted to hire the best and after looking at several other companies."
    },
    {
        firstname: "Lindsay",
        lastname: "swanson",
        designation: "Creative director",
        content: "Absolutely amazing theme, flexible and awesome design with possibilities. It's so easy to use and to customize. Simply the great designs and best theme for WooCommerce."
    },
    {
        firstname: "Jeremy",
        lastname: "dupont",
        designation: "Creative director",
        content: "I wanted to hire the best and after looking at several other companies, I knew Jacob was the perfect guy. I wanted to hire the best and after looking at several other companies."
    },
]

const TestimonialsCarouselData4 = [
    {
        firstname: "Alexander",
        lastname: "Harvard",
        designation: "ThemeZaa Design",
        title: "Just love their design for all stunning details!",
        content: "Lorem ipsum dolor sit consectetur adipiscing do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam nostrud exercitation ullamco laboris nisi.",
        img: "https://via.placeholder.com/148x148"
    },
    {
        firstname: "Shoko",
        lastname: "Mugikura",
        designation: "Google Design",
        title: "Every element is designed beautifully and perfect!",
        content: "Lorem ipsum dolor sit consectetur adipiscing do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam nostrud exercitation ullamco laboris nisi.",
        img: "https://via.placeholder.com/148x148"
    },
    {
        firstname: "Herman",
        lastname: "Miller",
        designation: "Apple Design",
        title: "Simple and easy to integrate and build the website!",
        content: "Lorem ipsum dolor sit consectetur adipiscing do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam nostrud exercitation ullamco laboris nisi.",
        img: "https://via.placeholder.com/148x148"
    },
]

const TestimonialsCarouselData5 = [
    {
        firstname: "harvard",
        lastname: "Alexander",
        designation: "Microsoft Design",
        content: "This theme has a wide variety of options and a really good customer support. But even so, the theme still gives a lot of features while prioritizing web speed.",
        img: "https://via.placeholder.com/359x359"
    },
    {
        firstname: "Mackangy",
        lastname: "Rose",
        designation: "Creative director",
        content: "Trust us we looked for a very long time and wasted thousands of dollars testing other teams, freelancers, and outsource companies. Excellent company!",
        img: "https://via.placeholder.com/359x359"
    },
    {
        firstname: "Jonsan",
        lastname: "Donner",
        designation: "Sales manager",
        content: "Their team are easy to work with and helped me make amazing websites in a short amount of time. Thanks guys for all your hard work. Professional support.",
        img: "https://via.placeholder.com/359x359"
    }
]

const TestimonialsCarouselData6 = [
    {
        firstname: "Alexander",
        lastname: "harvard",
        designation: "Creative director",
        content: "Every element is designed beautifully and pixel perfect, so it is really a modern theme. Support team is very kind. You don't need a web developer to use this theme. Simple and easy to integrate and build the whole website.",
        img: 'https://via.placeholder.com/125x125'
    },
    {
        firstname: "Jonsan",
        lastname: "Donner",
        designation: "Sales manager",
        content: "We see our customers as invited guests to a party and we are the hosts. It’s our job every day to make every important aspect of the customer experience a better. Everything is designed few things are designed well.",
        img: "https://via.placeholder.com/125x125"
    },
    {
        firstname: "Mackangy",
        lastname: "Rose",
        designation: "Creative director",
        content: "Out of all the themes that I have purchased and customized, this is the 1st one that didn't require any support. Support for this product has always been above and beyond, their technical team has been very reliable.",
        img: "https://via.placeholder.com/125x125"
    },
    {
        firstname: "Jeremy",
        lastname: "Smith",
        designation: "Design manager",
        content: "Every element is designed beautifully and pixel perfect, so it is really a modern theme. Support team is very kind. You don't need a web developer to use this theme. Simple and easy to integrate and build the whole website.",
        img: "https://via.placeholder.com/125x125"
    }
]

const TestimonialsCarouselData7 = [
    {
        firstname: "Shoko",
        lastname: "mugikura",
        designation: "Graphic designer",
        content: "Awesome theme and outstanding support. One of the best themes available out there. Design, coding, functionalities and possibilities are great!",
        img: "https://via.placeholder.com/187x187"
    },
    {
        firstname: "Mackangy",
        lastname: "rose",
        designation: "Creative director",
        content: "Are you looking for a website that's ready now, and you don’t know coding, stop browsing themeforest because nothing better. Loyal to themezaa.",
        img: "https://via.placeholder.com/187x187"
    },
    {
        img: "https://via.placeholder.com/187x187",
        content: "We see our customers as invited guests to a party and we are the hosts. It's our job every day to make every important aspect of the customer a better.",
        firstname: "Alexander",
        lastname: "harvard",
        designation: "Creative director"
    },
]

const TestimonialsCarouselData8 = [
    {
        firstname: "Colin",
        lastname: "Powell",
        designation: "Yoga trainer",
        content: "Undisturbed calmness of mind is attained by cultivating friendless toward the happy, compassion for the unhappy, delight in the virtuous, and indifference toward the wicked. Peace comes from within. Do not seek it without.",
        img: "https://via.placeholder.com/141x99"
    },
    {
        firstname: "Alexander",
        lastname: "harvard",
        designation: "Meditation expert",
        content: "When you listen to yourself, everything comes naturally. It comes from inside, like a kind of will to do something. Try to be sensitive. That is yoga. oga takes you into the present moment. The only place where life exists.",
        img: "https://via.placeholder.com/141x99"
    },
    {
        firstname: "Jeremy",
        lastname: "Girard",
        designation: "Yoga trainer",
        content: "Yoga is a great practice for both the body and the mind, it offers peace and mindfulness to its lovers and helps them get through daily stress. Yoga does not just change the way we see things, it transforms the person who sees.",
        img: "https://via.placeholder.com/141x99"
    }
]

const TestimonialsCarouselData9 = [
    // {
    //     firstname: "Bala",
    //     lastname: "Murugan",
    //     title: "Web Development",
    //     content: "The educational site has 200 users, with over 10,000 projected, and boasts a colorful, user-friendly design. The young team’s fresh and creative ideation enabled them to listen well and deliver on-site goals and vision. Their responsive communication and cost-effectiveness earned further trust.",
    //     img: "/assets/img/webp/siva.png",
    //     thumbimg: "/assets/img/webp/siva.png"
    // },
    {
        firstname: "Subbramanian",
        lastname: "Meenakshisundaram",
        title: "Custome software development, Web development",
        content: "HasoTechnology delivered both projects successfully. In addition to their technical and business knowledge, the team is characterized by open-mindedness and a strong commitment to service.",
        img: "/assets/img/webp/lion.webp",
        thumbimg: "/assets/img/webp/lion.webp"
    },
    {
        firstname: "Suhan",
        lastname: "Selvan",
        title: "Web Development",
        content: "The website is smooth and intuitive; the clients are pleased. HasoTechnology has a young team that is still learning, but that makes up for it with their creative approach to development and project management. They respond quickly and take suggestions well.",
        img: "/assets/img/webp/whar.webp",
        thumbimg: "/assets/img/webp/whar.webp",
    },
    {
        firstname: "Ajit",
        lastname: "Veerappan",
        title: "Custom Software Development, HR Consulting",
        content: "Thanks to HasoTechnology's effort, they have provided resources in a timely manner. They have gone the extra mile to ensure the project's success. The team is punctual and hard-working. ",
        img: "/assets/img/webp/abi.webp",
        thumbimg: "/assets/img/webp/abi.webp"
    },
    {
        firstname: "Dr",
        lastname: "Ravishankar",
        title: "Custom Software Development, Web development",
        content: "They are a really fantastic group of developers who are interested in working on new projects.",
        img: "/assets/img/webp/drc.webp",
        thumbimg: "/assets/img/webp/drc.webp"
    },
    {
        firstname: "Bala",
        lastname: "Murugan",
        title: "Custom Software Development, Web development",
        content: "The educational site has 200 users, with over 10,000 projected, and boasts a colorful, user-friendly design. The young team’s fresh and creative ideation enabled them to listen well and deliver on-site goals and vision. Their responsive communication and cost-effectiveness earned further trust.",
        img: "/assets/img/webp/beautyconnect.webp",
        thumbimg: "/assets/img/webp/beautyconnect.webp"
    },
]

export { TestimonialsCarouselData1, TestimonialsCarouselData2, TestimonialsCarouselData3, TestimonialsCarouselData4, TestimonialsCarouselData5, TestimonialsCarouselData6, TestimonialsCarouselData8, TestimonialsCarouselData7, TestimonialsCarouselData9 }